import { c as _c } from "react/compiler-runtime";
import { QueryParams } from "@router/route-params";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
/**
 * Generic hook for managing a sorting parameter in the URL
 */
export function useSortingQueryParam(t0) {
  const $ = _c(24);
  const {
    defaultSort,
    isValidSort
  } = t0;
  const [searchParams, setSearchParams] = useSearchParams();
  const hasReadSortQueryParam = useRef(false);
  let t1;
  let urlSortBy;
  if ($[0] !== isValidSort || $[1] !== searchParams) {
    urlSortBy = searchParams.get(QueryParams.sortBy);
    t1 = urlSortBy !== null && !isValidSort(urlSortBy);
    $[0] = isValidSort;
    $[1] = searchParams;
    $[2] = t1;
    $[3] = urlSortBy;
  } else {
    t1 = $[2];
    urlSortBy = $[3];
  }
  const isUrlSortByUnusable = t1;
  let t2;
  bb0: {
    if (isValidSort(urlSortBy)) {
      t2 = urlSortBy;
      break bb0;
    }
    t2 = defaultSort;
  }
  const newSortBy = t2;
  const [sortBy, setSortBy] = useState(newSortBy);
  let t3;
  if ($[4] !== defaultSort || $[5] !== searchParams || $[6] !== setSearchParams) {
    t3 = newSortBy_0 => {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      if (newSortBy_0 === defaultSort) {
        newSearchParams.delete(QueryParams.sortBy);
      } else {
        newSearchParams.set(QueryParams.sortBy, newSortBy_0);
      }
      setSearchParams(newSearchParams, {
        replace: true
      });
    };
    $[4] = defaultSort;
    $[5] = searchParams;
    $[6] = setSearchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const setNewSortBy = t3;
  let t4;
  let t5;
  if ($[8] !== defaultSort || $[9] !== isUrlSortByUnusable || $[10] !== setNewSortBy) {
    t4 = () => {
      if (isUrlSortByUnusable) {
        setSortBy(defaultSort);
        setNewSortBy(defaultSort);
      }
    };
    t5 = [isUrlSortByUnusable, defaultSort, setNewSortBy];
    $[8] = defaultSort;
    $[9] = isUrlSortByUnusable;
    $[10] = setNewSortBy;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[13] !== newSortBy) {
    t6 = () => {
      if (!hasReadSortQueryParam.current) {
        hasReadSortQueryParam.current = true;
        setSortBy(newSortBy);
      }
    };
    t7 = [newSortBy];
    $[13] = newSortBy;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[16] !== isUrlSortByUnusable || $[17] !== newSortBy || $[18] !== setNewSortBy || $[19] !== sortBy) {
    t8 = () => {
      if (!hasReadSortQueryParam.current || isUrlSortByUnusable) {
        return;
      }
      if (sortBy !== newSortBy) {
        setNewSortBy(sortBy);
      }
    };
    t9 = [sortBy, newSortBy, isUrlSortByUnusable, setNewSortBy];
    $[16] = isUrlSortByUnusable;
    $[17] = newSortBy;
    $[18] = setNewSortBy;
    $[19] = sortBy;
    $[20] = t8;
    $[21] = t9;
  } else {
    t8 = $[20];
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  if ($[22] !== sortBy) {
    t10 = {
      sortBy,
      setSortBy
    };
    $[22] = sortBy;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}